module.exports = __webpack_public_path__ + "img/appBg-Auth--Gradient.db6815c6.svg";